import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Carousel, Image } from 'react-bootstrap';
import breakfast from './lanches/breakfast-1804436_640.jpg'
import diet from './lanches/diet-695723_640.jpg'
import lime from './lanches/lime-907124_640.jpg'
import sandwich from './lanches/sandwich-1238615_640.jpg'
import vegetableJuice from './lanches/vegetable-juices-1725835_640.jpg'
function Inicio() {
  return (
    <Carousel variant="dark">
      <Carousel.Item>
        <Image
          className="d-block w-100"
          src={breakfast}
          alt=""
        />
        <Carousel.Caption>
          <h3>Humm! café da manhã</h3>
          <p>Comece bem a rotina do dia.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Image
          className="d-block w-100"
          src={diet}
          alt=""
        />
        <Carousel.Caption>
          <h3>Refeição sob medida...</h3>
          <p>Nada melhor que comer bem.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Image
          className="d-block w-100"
          src={lime}
          alt=""
        />
        <Carousel.Caption>
          <h3>Natural é perfeito</h3>
          <p>
            Tim, tim?
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Image
          className="d-block w-100"
          src={sandwich}
          alt=""
        />
        <Carousel.Caption>
          <h3>Oh, oh, oh</h3>
          <p>
            Resisti?
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Image
          className="d-block w-100"
          src={vegetableJuice}
          alt=""
        />
        <Carousel.Caption>
          <h3>Comprar esse template</h3>
          <p>
            Link: <a href="https://aondenet.com/">Sinval Gomes</a>.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Inicio;
